angular.module('core')
    .controller('sortableCtrl', function ($scope, $location) {
        $scope.sort = (pageable, columnName) => {
            let prevCol = sortColumn(pageable.sort);

            if (columnName === prevCol) {
                $location.search("page", null);
                $location.search("sort", switchedDirection(pageable.sort));
            } else {
                $location.search("sort", columnName);
            }
        };

        function sortColumn(sort) {
            let sortArray = sort.split(',');
            if (sortArray.length > 1) {
                sortArray.pop();
            }
            return sortArray.join(',');
        }

        function switchedDirection(sort) {
            let columnName = sortColumn(sort);
            return [columnName, isAscending(sort) ? "desc" : "asc"].join(",")
        }

        function isAscending(sort) {
            let sortArray = sort.split(',');
            if (sortArray.length > 1) {
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }
    })
    .controller('stateFilterCtrl', function ($scope, $state) {
        $scope.search = () => {
            $state.go($state.current, $scope.filters, {inherit: false, reload: false, notify: true});
        };
        $scope.search = filters => {
            $state.go($state.current, filters, {inherit: false, reload: true, notify: false});
            // $state.go($state.current, filters, {inherit: false, reload: false, notify: true});
            // $state.transitionTo('^', $state.current, filters, {inherit: false, reload: false, notify: false});
        };
        $scope.reset = () => {
            $scope.filters = null
            $state.go($state.current, null, {inherit: false});
        };
        $scope.reset = filters => {
            filters = null
            $state.go($state.current, null, {inherit: false, reload: true, notify: true});
        };
    })
    .run(function (uibPaginationConfig) {
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    });
